/* date-time-picker-container.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./date-time-picker-container.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
var isInvalidBorderStyles = null;
var isFocusedBorderStyles = null;
var isFocusedStyles = null;
var subtleBgStyles = null;
var subtleFocusedBgStyles = null;
var noBgStyles = null;
var hoverStyles = null;
var isInvalidHoverStyles = null;
var isDisabledStyles = null;
var newBorderStyles = null;
var baseContainerStyles = null;
/**
 * This is the container for the datetime picker component.
 */
export var DateTimePickerContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    appearance = _ref.appearance,
    isInvalid = _ref.isInvalid,
    innerProps = _ref.innerProps,
    testId = _ref.testId;
  var notFocusedOrIsDisabled = !(isFocused || isDisabled);

  // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
  return /*#__PURE__*/React.createElement("div", _extends({}, innerProps, {
    "data-testid": testId,
    ref: ref,
    className: ax(["_2rkoglpi _v564r5cv _1e0c1txw _bfhk1j9a _d0altlke", "_19itp69y", isDisabled && "_1h6d13gt _bfhksyzs _d0al73ad", isFocused && "_bfhkr01l", appearance === 'subtle' && isFocused && "_1h6d1j28 _bfhk1y3p", appearance === 'subtle' && !isFocused && "_1h6d1j28 _bfhk1j28", isFocused && "_1h6d1p6i _16qsic8z", isInvalid && "_1h6d1bqt", notFocusedOrIsDisabled && isInvalid && "_4cvx1bqt _irr31d5g", notFocusedOrIsDisabled && !isInvalid && "_4cvx1elr _irr31d5g", appearance === 'none' && "_1h6d1j28 _bfhk1j28 _4cvx1j28 _irr31j28"]),
    style: {
      "--_1p9iyo2": ix("var(--ds-border-width, 1px)".concat(" solid ", "var(--ds-border-input, #8590A2)")),
      "--_1p9nqfm": ix("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-focused, #388BFF)"))
    }
  }), children);
});